export default function pagination() {
    let pageNumber = document.querySelector('[name="pagenumber"]')

    if (!pageNumber) {
        return
    }

    pageNumber.addEventListener('keyup', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            if (!isNaN(pageNumber.value)) {
                if (parseInt(pageNumber.value) < pageNumber.min) {
                    pageNumber.value = 1
                    return
                }

                if (parseInt(pageNumber.value) > pageNumber.max) {
                    pageNumber.value = pageNumber.max
                    return
                }

                window.location.href = updateQueryStringParameter(
                    window.location.href,
                    'page',
                    pageNumber.value
                )
            } else {
                pageNumber.value = 1
                return
            }
        }
    })

    // append or update existing page query param
    // https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
        var separator = uri.indexOf('?') !== -1 ? '&' : '?'

        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2')
        } else {
            return uri + separator + key + '=' + value
        }
    }
}
